export default __webpack_public_path__ + "static/25833-599633e4cd3858c8d74b075e0e20ca5b.jpg";